module.exports = (__webpack_require__(3))(6);


//////////////////
// WEBPACK FOOTER
// delegated ./src/dialog.js from dll-reference girder_lib
// module id = 68
// module chunks = 0